import { render, staticRenderFns } from "./SubmitForm4.vue?vue&type=template&id=52e4a9c9&scoped=true"
import script from "./SubmitForm4.vue?vue&type=script&lang=ts"
export * from "./SubmitForm4.vue?vue&type=script&lang=ts"
import style0 from "./SubmitForm4.vue?vue&type=style&index=0&id=52e4a9c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4a9c9",
  null
  
)

export default component.exports